import { render, staticRenderFns } from "./CreateForm2.vue?vue&type=template&id=64272eb6&scoped=true"
import script from "./CreateForm2.vue?vue&type=script&lang=js"
export * from "./CreateForm2.vue?vue&type=script&lang=js"
import style0 from "./CreateForm2.vue?vue&type=style&index=0&id=64272eb6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64272eb6",
  null
  
)

export default component.exports